import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Loader } from '@els/els-react--loader';
import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';

function RoutesLoaderInProgress({ type }) {
  return (
    <>
      <div
        className={cn(
          'project-status-grid-item__routes-loader',
          'project-status-grid-item__routes-loader--in-progress',
          `project-status-grid-item__routes-loader--${type}`
        )}
        style={{ padding: '2rem' }}>
        <Loader isVisible isBlocking={false} isSmall />
      </div>
      <span className="project-status-grid-item__routes-loader-label">In progress</span>
    </>
  );
}

RoutesLoaderInProgress.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
};

export default RoutesLoaderInProgress;
